import { GroupAction, GroupActionTypes, GroupList, Group } from "./groupTypes";

export const getGroupListAction = (list: GroupList): GroupAction => ({
  type: GroupActionTypes.GET_GROUP_LIST,
  payload: list,
});

export const postIdToSwitchGroupAction = (group: Group) => ({
  type: GroupActionTypes.POST_ID_TO_SWITCH_GROUP,
  payload: { group, selected: true },
});

export const setSelectedAction = (selected: boolean) => ({
  type: GroupActionTypes.SET_SELECTED,
  payload: selected,
});
